import { Component, inject, ChangeDetectionStrategy } from '@angular/core'
import { TranslationService } from '../../../services/translation.service'
import { ReportsListComponent } from './reports-list/reports-list.component'
import { MatIconModule } from '@angular/material/icon'
import { Router, RouterModule } from '@angular/router'
import { MatButtonModule } from '@angular/material/button'

@Component({
  selector: 'app-reports',
  imports: [ReportsListComponent, MatIconModule, MatButtonModule, RouterModule],
  templateUrl: './reports.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './reports.component.scss',
})
export class ReportsComponent {
  translationService = inject(TranslationService)
  router = inject(Router)
}
